<template>
    <div class="container-fluid px-2 py-0">
        <!-- List View -->
        <x-panel class="px-0">
            <el-table
                :data="displayListData"
                @selection-change="handleSelectionChange"
                style="width: 100%"
                height="70vh"
                fit
                ref="filterTable"
                @sort-change="handleSortChange"
                :key="tableKey"
                :row-key="setRowKeys"
                :default-sort="{ prop: 'updated_at', order: 'descending' }"
            >
                <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
                <el-table-column key="0" prop="customer_name" sortable="custom" label="Name" width="150">
                    <template slot-scope="scope">

                        <!--Change This to only work on ( x ) conditions (Look at Notion)-->
                        <el-link width="100"
                            @click="handleRowClick(scope.row)"
                        >
                            {{ scope.row.customer_name || "Open App" }}
                        </el-link>

                        <el-link
                            @click="handleRowClick(scope.row)"
                        >
                            {{ scope.row.ref_id }}
                        </el-link>

                        <el-link
                            v-if="scope.row.applicant_1_phone"
                            icon="el-icon-phone"
                            :href="`tel://${
								(_.get(config, 'call_prefix') != null ? config.call_prefix : '') + scope.row.applicant_1_phone.toString().replace(/\s+/g, '')
							}`"
                        >
                            {{ scope.row.applicant_1_phone.toString().replace(/\s+/g, "") }}
                        </el-link>

                        <el-link
                            v-else-if="scope.row.customer_phone"
                            icon="el-icon-phone"
                            :href="`tel://${
								(_.get(config, 'call_prefix') != null ? config.call_prefix : '') + scope.row.customer_phone.toString().replace(/\s+/g, '')
							}`"
                        >
                            {{ scope.row.customer_phone.toString().replace(/\s+/g, "") }}
                        </el-link>

                    </template>
                </el-table-column>

                <el-table-column
                    prop="application_categories"
                    label="Category"
                    width="150">
                    <template slot-scope="scope">
                        <div v-if="!_.isEmpty(scope.row.application_categories)" class="category-item">
                            <span v-for="uid in scope.row.application_categories" :key="uid">
                                <el-tooltip class="item" effect="dark" :content="getCategory(uid, 'name')"
                                            placement="top">
                                    <div :style="`background: ${getCategory(uid, 'colour')} !important`"
                                         class="category-dot">&nbsp;</div>
                                </el-tooltip>
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="postcode"
                    label="Postcode"
                    width="100"
                    v-if="isColumnActive('Postcode')">
                </el-table-column>
                <el-table-column
                    key="1"
                    prop="application_status_id"
                    label="Status"
                    sortable="custom"
                    width="200"
                    v-if="isColumnActive('Status')"
                >
                    <template slot-scope="scope">
                        <el-tag
                            :type="_.get(scope.row, 'application_status.name', scope.row.application_status) || 'lead'"
                            disable-transitions
                        >
                            {{ _.get(scope.row, "application_status.name", scope.row.application_status) || "lead" }}
                        </el-tag>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    key="2"
                    sortable="custom"
                    label="Reference ID"
                    width="150"
                    v-if="isColumnActive('Reference Id')"
                >
                    <template slot-scope="scope">
                        <el-link
                            @click="handleRowClick(scope.row)"
                        >
                            {{ scope.row.ref_id }}
                        </el-link>
                    </template>
                </el-table-column> -->
                <el-table-column key="4" prop="asset" label="Asset" sortable="custom" width="150"
                                 v-if="isColumnActive('Asset')">
                    <template slot-scope="scope">
                        <el-image
                            class="mr-2"
                            style="width: 30px; height: 30px"
                            :src="scope.row.is_insurance_deal ? icons['Insurance'] : icons[_.get(scope.row, 'asset', 'Personal')]"
                            fit="scale-down"
                        ></el-image>
                        <el-tag class="mr-2">${{ scope.row.amount || "0.00" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    key="5"
                    prop="broker_name"
                    label="Assigned"
                    sortable="custom"
                    width="250"
                    v-if="isColumnActive('Assigned')"
                >
                    <template slot-scope="scope">
                        <span class="text-nowrap text-truncate">{{ scope.row.broker_name || "Not Assigned" }}</span>
                        <el-tooltip
                            v-if="scope.row.support_users && Object.keys(scope.row.support_users).length"
                            class="item"
                            effect="dark"
                            :content="`Supported by ${Object.values(scope.row.support_users).join(', ')}`"
                            placement="top-start"
                        >
                            <i class="el-icon-user-solid text-info"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                    key="7"
                    v-if="isColumnActive('Referrer') && !isReferrer"
                    prop="referrer"
                    label="Referrer"
                    sortable="custom"
                    min-width="200"
                >
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.referrer" placement="bottom-start">
                            <span class="text-nowrap text-truncate">{{ scope.row.referrer }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column key="8" v-if="isReferrer" prop="referrer_user" label="Referrer User" sortable="custom"
                                 min-width="150">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.referrer_user"
                                    placement="bottom-start">
                            <span class="text-nowrap text-truncate">{{ scope.row.referrer_user }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                    key="9"
                    label="Lender"
                    prop="approved_lender"
                    sortable="custom"
                    min-width="150"
                    v-if="isColumnActive('Lender')"
                >
                    <template slot-scope="scope">
                        <el-popover
                            v-if="scope.row.approved_lender != null"
                            placement="top"
                            :title="scope.row.approved_loan_tier ? scope.row.approved_loan_tier : scope.row.last_approved_loan_tier"
                            width="auto"
                            popper-class="max-400"
                            trigger="hover"
                            :content="scope.row.approved_lender ? scope.row.approved_lender : scope.row.last_submitted_loan_tier"
                        >
                            <el-image
                                slot="reference"
                                class="d-flex justify-content-end align-items-center"
                                v-if="scope.row.approved_lender_logo ? scope.row.approved_lender_logo : scope.row.last_submitted_lender_logo"
                                style="width: 100px; height: 28px; mix-blend-mode: multiply"
                                :src="scope.row.approved_lender_logo ? scope.row.approved_lender_logo : scope.row.last_submitted_lender_logo"
                                fit="scale-down"
                            >
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                    key="11"
                    prop="last_stage_change"
                    label="Time in stage"
                    sortable="custom"
                    width="200"
                    v-if="isColumnActive('Time in stage')"
                >
                    <template slot-scope="scope">
                        <span class="text-nowrap text-truncate">{{
                                scope.row.last_stage_change | moment("from", "now", true)
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column key="10" align="right" label="Actions" width="250">
                    <template slot-scope="scope">
                        <el-row class="d-flex align-items-center justify-content-around">
                            <el-button
                                icon="fas fa-tasks"
                                circle
                                size="mini"
                                @click.prevent.stop="tasksModal(scope.row)"
                                v-if="!isReferrer"
                                :type="checkTaskStatus(scope.row.tasks)"
                            ></el-button>
                            <el-popover
                                v-if="scope.row.last_note != null && !isReferrer"
                                placement="top"
                                :title="scope.row.last_note.notes"
                                width="auto"
                                popper-class="max-400"
                                trigger="hover"
                                :content="(scope.row.last_note.updated_at + 'Z') | moment('DD/MM/YYYY LT')"
                            >
                                <el-button
                                    slot="reference"
                                    @click.prevent.stop="createNote(scope.row)"
                                    icon="el-icon-edit"
                                    circle
                                    size="mini"
                                    class="mx-2 note"
                                    type="warning"
                                ></el-button>
                            </el-popover>
                            <el-button v-else icon="el-icon-edit" @click.prevent.stop="createNote(scope.row)" circle
                                       size="mini"></el-button>
                            <file-upload
                                :modal="true"
                                :title="`Upload for ${scope.row.customer_name}`"
                                :endpoint="'/api/application/conditioning/' + scope.row.id + '/document'"
                                label="Drop documents here to upload <b><em>or</em></b> <span style='text-decoration: underline;'>click to browse</span>"
                                :circle="true"
                            />
                            <el-button
                                v-if="!isReferrer"
                                icon="el-icon-message"
                                @click="sendMessage(scope.row.id)"
                                circle
                                size="mini"
                            ></el-button>

                            <el-tooltip
                                v-if="Ambition.getGlobal('tenant.pbx_active') && scope.row.application_status_id == null"
                                class="item" effect="dark" content="Call History" placement="bottom">
                                <el-popover
                                    placement="top"
                                    width="auto"
                                    popper-class="max-400"
                                    trigger="hover">
                                    <div>
                                        <h4 class="mt-2">Call History</h4>
                                        <hr/>
                                        <table v-if="_.get(scope.row, 'call_history.0')" class="table mini mb-0">
                                            <tbody>
                                            <tr v-for="call in scope.row.call_history" :key="call.id">
                                                <td><strong>{{
                                                        call.created_at + "Z" | moment("ddd DD/MM/YY LT")
                                                    }}</strong></td>
                                                <td v-html="call.message"></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <div v-else>No Calls Available</div>
                                    </div>
                                    <el-button @click.prevent="" slot="reference" icon="el-icon-phone" circle
                                               size="mini" class="mx-2"
                                               :type="checkSameDay(_.get(scope.row, 'contacted.datetime')) ? _.get(scope.row, 'contacted.status', 'danger') : 'danger'"></el-button>
                                </el-popover>
                            </el-tooltip>
                            <el-tooltip
                                v-if="Ambition.getGlobal('tenant.pbx_active') && scope.row.application_status_id != null"
                                class="item" effect="dark" content="Call History" placement="bottom">
                                <el-popover
                                    placement="top"
                                    width="auto"
                                    popper-class="max-400"
                                    trigger="hover">
                                    <div>
                                        <h4 class="mt-2">Call History</h4>
                                        <hr/>
                                        <table v-if="_.get(scope.row, 'call_history.0')" class="table mini mb-0">
                                            <tbody>
                                            <tr v-for="call in scope.row.call_history" :key="call.id">
                                                <td><strong>{{
                                                        call.created_at + "Z" | moment("ddd DD/MM/YY LT")
                                                    }}</strong></td>
                                                <td v-html="call.message"></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <div v-else>No Calls Available</div>
                                    </div>
                                    <el-button @click.prevent="" slot="reference" icon="el-icon-phone" circle
                                               size="mini" class="mx-2"></el-button>
                                </el-popover>
                            </el-tooltip>
                            <el-popover placement="top" width="auto" popper-class="max-400" trigger="hover">
                                <div v-if="_.get(scope.row, 'all_history')">
                                    <h4 class="mt-2">Application History</h4>
                                    <hr/>
                                    <table class="table mini mb-0">
                                        <tbody v-if="_.get(scope.row, 'all_history')">
                                        <tr v-for="history in scope.row.all_history" :key="history.id">
                                            <td>
                                                <strong>{{
                                                        (history.created_at + "Z") | moment("ddd DD/MM/YY LT")
                                                    }}</strong>
                                            </td>
                                            <td v-html="history.message"></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <el-button slot="reference" icon="el-icon-time" circle size="mini"></el-button>
                            </el-popover>
                            <el-popover placement="top" width="auto" popper-class="max-400" trigger="hover"
                                        v-if="_.get(scope.row, 'assetObject.additional.expectedDate')">
                                <div v-if="_.get(scope.row, 'all_history')">
                                    <h4 class="mt-2">Expected Delivery Date</h4>
                                    <hr/>
                                    <table class="table mini mb-0">
                                        <tbody v-if="_.get(scope.row, 'assetObject.additional.expectedDate')">
                                        <tr>
                                            <td v-html="'Expected Delivery Date is on the ' +_.get(scope.row, 'assetObject.additional.expectedDate')"></td>


                                            <td>
                                                <strong>
                                                    {{
                                                        _.get(scope.row, 'created_at' + "Z") | moment("ddd DD/MM/YY LT")
                                                    }}
                                                </strong>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <el-button slot="reference" icon="el-icon-date" circle size="mini"></el-button>
                            </el-popover>
                        </el-row>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="py-4"
                v-show="totalApps > 0"
                @size-change="handlePaginationSizeChange"
                @current-change="handlePaginationChange"
                :current-page.sync="pagination.page"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalApps"
            ></el-pagination>
        </x-panel>

        <el-dialog title="Customise List View" :visible.sync="customTableSettings.modal">
            <div class="row">
                <div class="col-6">
                    <h4>Available</h4>
                    <draggable
                        class="list-group min-with-boarder"
                        :list="availableTableColumns"
                        group="columns"
                        @change="refreshVisibleTableColumns"
                    >
                        <el-tag class="list-group-item" v-for="element in availableTableColumns" :key="element.name">
                            <span class="p-2 mr-2"><i class="fas fa-ellipsis-v"></i></span>
                            {{ element.name }}
                        </el-tag>
                    </draggable>
                </div>

                <div class="col-6">
                    <h4>Showing</h4>
                    <draggable
                        class="list-group min-with-boarder"
                        :list="_.get(this.tableSettings, 'columnsInUse')"
                        group="columns"
                        @change="refreshVisibleTableColumns"
                    >
                        <el-tag class="list-group-item" v-for="element in _.get(this.tableSettings, 'columnsInUse')"
                                :key="element.name">
                            <span class="pr-2 mr-2"><i class="fas fa-ellipsis-v"></i></span>
                            {{ element.name }}
                        </el-tag>
                    </draggable>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="customTableSettings.modal = false">Cancel</el-button>
				<el-button type="primary" @click="handleTableSettingsChange">Save Settings</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
import draggable from "vuedraggable"
import {mapGetters} from "vuex"
import {Message, Popover} from "element-ui"

export default {
    name: "ApplicationsTableViewComponent",
    components: {
        draggable,
        Message,
        Popover,
    },
    props: {
        applications: {
            type: Array,
            required: true,
        },
        stages: {
            type: Array,
            required: true,
        },
        config: {
            type: Object,
            default: () => ({}),
        },
        tokenInitial: {
            required: false,
        },
        isBroker: {
            required: false,
        },
        viewUnassigned: {
            required: false,
        },
        closeReasons: {
            required: false,
        },
        canAssignApp: {
            required: false,
        },
        canViewAllApps: {
            required: false,
        },
        isReferrer: {
            required: false,
        },
        referrerUserId: {
            required: false,
        },
        referrerId: {
            required: false,
        },
        canMakeInsuranceDeal: {
            required: false,
        },
        totalApps: {
            required: true,
        },
        search: {
            required: false,
        },
        icons: {
            required: true,
        },
    },
    data() {
        return {
            sortby: {
                sorting: false,
                column: {},
                prop: "",
                order: "",
            },
            pagination: {
                page: 1,
                pageSize: 20,
            },
            tableKey: 0,
            customTableSettings: {
                modal: false,
                columnsInUse: [],
                customTableColumns: [
                    {name: "Assigned"},
                    {name: "Postcode"},
                    {name: "Asset"},
                    {name: "Status"},
                    {name: "Reference Id"},
                    {name: "Referrer"},
                    {name: "Lender"},
                    {name: "Time in stage"},
                ],
            },
        }
    },
    computed: {
        ...mapGetters({
            tableSettings: "userSettings/tableSettings",
            getPermissionByName: "user/getPermissionByName",
            user: "user/user",
            applicationCategories: "options/applicationCategories",
        }),

        checked: {
            get() {
                return this.$store.getters["applicationsDashboard/getChecked"]
            },
            set(data) {
                this.$store.dispatch("applicationsDashboard/setChecked", data);
            }
        },

        availableTableColumns() {
            let columnsInUse = _.get(this.tableSettings, "columnsInUse")
            let available = _.differenceWith(this.customTableSettings.customTableColumns, columnsInUse, _.isEqual)

            return available
        },

        displayListData() {
            this.pagination.filtered = this.applications.filter((data) => {
                return this.search
                    .toLowerCase()
                    .split(" ")
                    .every((v) => {
                        // Search Customer Name
                        if (_.get(data, 'customer_name')) {
                            if (data.customer_name.toLowerCase().includes(v)) {
                                return data
                            }
                        }
                    })
            });

            if (this.sortby.sorting) {
                if (this.sortby.order == "ascending") {
                    this.pagination.filtered.sort((a, b) => (a[this.sortby.prop] > b[this.sortby.prop] ? 1 : -1))
                }
                if (this.sortby.order == "descending") {
                    this.pagination.filtered.sort((a, b) => (a[this.sortby.prop] < b[this.sortby.prop] ? 1 : -1))
                }
            } else {
                this.pagination.filtered.sort((a, b) => (a.application_status_id > b.application_status_id ? 1 : -1))
            }

            this.pagination.total = this.pagination.filtered.length
            return this.pagination.filtered.slice(
                this.pagination.pageSize * this.pagination.page - this.pagination.pageSize,
                this.pagination.pageSize * this.pagination.page
            )
        },
    },
    watch: {},
    mounted() {
        this.$bus.$on("applicationTab::open::tableSettings", (option) => {
            this.customTableSettings.modal = option
        })
        this.pagination.pageSize = this.tableSettings.pageSize
    },
    updated() {
    },
    activated() {
    },
    methods: {
        getCategory(uid, key) {
            let category = this.applicationCategories.find(category => category.uid == uid)
            if (category) {
                return _.get(category, key, '')
            }
        },
        formatDate(value) {
            if (value) return this.$moment.utc(value).tz(this.user.timezone).format("ddd DD/MM/YY LT")
            else return null
        },

        setRowKeys(row) {
            return row.id
        },

        clearSelection() {
            this.$refs.filterTable.clearSelection()
        },

        apiToken() {
            return {
                headers: {Authorization: `Bearer ${this.tokenInitial}`},
            }
        },

        formatDate(date) {
            return this.$moment.utc(date).tz(this.$store.getters["user/user"].timezone).format("ddd DD/MM/YY LT")
        },

        isColumnActive(column) {
            if (Ambition.User.isNonAcrReferrer && column === "Lender") return false

            if (_.get(this.tableSettings, "columnsInUse", false)) {
                let active = this.tableSettings.columnsInUse.find((item) => {
                    return column == item.name
                })

                return active ? true : false
            }

            return true
        },

        handleSelectionChange(val) {
            let data = {}
            val.forEach((row) => {
                return (data[row.id] = true)
            })

            this.checked = data
        },

        handlePaginationChange(val) {
            this.$emit("loading", true)
            this.pagination.page = val
            setTimeout(() => {
                this.$emit("loading", false)
            }, 2000)
        },

        handleSortChange(sortby) {
            if (sortby.order == null) {
                sortby.sorting = false
            } else {
                sortby.sorting = true
            }

            this.sortby = sortby
        },

        handlePaginationSizeChange(val) {
            this.$emit("loading", true)
            this.pagination.pageSize = val
            this.$store.dispatch("global commit", {
                type: "userSettings/setApplicationTableSettings",
                payload: {pageSize: this.pagination.pageSize},
            })
            this.setPreferredTableOptions()
            setTimeout(() => {
                this.$emit("loading", false)
            }, 2000)
        },

        handleTableSettingsChange() {
            this.$emit("loading", true)
            this.customTableSettings.modal = false
            this.$store.dispatch("global commit", {
                type: "userSettings/setApplicationTableSettings",
                payload: {columnsInUse: this.tableSettings.columnsInUse},
            })
            this.setPreferredTableOptions()
            setTimeout(() => {
                this.$emit("loading", false)
            }, 2000)
        },

        refreshVisibleTableColumns() {
            this.$emit("loading", true)
            this.tableKey = Math.random()
            this.$emit("loading", false)
        },

        setPreferredTableOptions() {
            this.$tenant
                .put(
                    "/api/v2/user-settings",
                    {
                        ApplicationTableSettings: {
                            pageSize: this.pagination.pageSize,
                            columnsInUse: this.tableSettings.columnsInUse,
                        },
                    }
                )
                .then((res) => {
                })
        },

        handleRowClick(row) {
            let url = ''
            if (this.isReferrer) {
                url = `${row.search_url}/stage/application`
                if (!Ambition.hasRoleOrPermission(['open application row']) && row.assigned != 0) {
                    console.warn(row)
                    return;
                }
            } else {
                url = `${row.search_url}${_.get(
                    this.stages.find((e) => e.value == row.application_status_id),
                    "stageUrl",
                    ""
                )}`
            }
            window.open(url)
        },

        tasksModal(application) {
            let task = null
            let create = true
            let applicationId = application.id
            if (application.tasks !== null) {
                task = application.tasks
                create = false
            }
            if (applicationId) {
                this.$bus.$emit("open-create-modal", {
                    selected: "Task",
                    create: create,
                    applicationId: applicationId,
                    task: task,
                })
            }
        },
        createTask(applicationId = 1) {
            this.applicationId = applicationId
            this.$bus.$emit("open-create-modal", {
                selected: "Task",
                applicationId: applicationId,
            })
        },
        editTaskEmit(data) {
            this.$bus.$emit("open-edit-modal", {data: data, type: "Task"})
        },

        createNote(application) {
            this.$emit("create-note", application)
        },
        sendMessage(applicationId = 1) {
            this.$bus.$emit("open-create-modal", {
                selected: "Send Message",
                applicationId: applicationId,
            })
        },

        checkTaskStatus(task) {
            if (task == null || task.status_id != 1) return

            return this.$moment(`${task.due_date} ${task.time}`, "YYYY/MM/DD hhmm").isBefore()
                ? "danger"
                : this.$moment(`${task.due_date} ${task.time}`, "YYYY/MM/DD").isAfter()
                    ? "primary"
                    : "success"
        },
        checkSameDay(datetime) {
            return datetime ? this.$moment(datetime).isSame(this.$moment(), 'day') : false
        }
    },
}
</script>

<style lang="scss" scoped>

.category-item {
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center !important;
    min-height: 33px;

    .category-dot {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        margin-right: 10px;
    }
}

.min-with-boarder {
    min-height: 15rem;
    margin-top: 1rem;
    border: 1px solid #ccc;
}

// @import '@assets/sass/backend/_core-variables.scss';
</style>
